/**
 * Provenance for every photograph in the app. Generated from assets-src/CREDITS.json
 * when the images are sourced; the CC BY entries are why the credits page exists.
 */
export interface PhotoCredit {
  readonly file: string
  readonly title: string
  readonly creator: string
  readonly license: string
  readonly attributionRequired: boolean
  readonly source: string
}

export const PHOTO_CREDITS: readonly PhotoCredit[] = [
  {
    file: "travel/cities/bogota.webp",
    title: "20160713-FAS-LSC-0242 (1)",
    creator: "USDAgov",
    license: "Public Domain Mark",
    attributionRequired: false,
    source: "https://www.flickr.com/photos/41284017@N08/28312418945",
  },
  {
    file: "travel/cities/mexico-city.webp",
    title: "Mexico City Skyline",
    creator: "arnaudmatar",
    license: "CC0 1.0",
    attributionRequired: false,
    source: "https://www.flickr.com/photos/140880057@N04/40327565134",
  },
  {
    file: "travel/cities/santa-cruz.webp",
    title: "Vista panorámica de Santa Cruz de la Sierra (Bolivia)",
    creator: "Aamariscal",
    license: "CC0 1.0",
    attributionRequired: false,
    source: "https://commons.wikimedia.org/w/index.php?curid=168864688",
  },
  {
    file: "travel/cities/sao-paulo.webp",
    title: "São Paulo - Skyline by night",
    creator: "Andre Deak",
    license: "CC0 1.0",
    attributionRequired: false,
    source: "https://www.flickr.com/photos/30578078@N00/1816831388",
  },
  {
    file: "travel/hotels/casa-arrieta.webp",
    title: "New Arbat Avenue 32 2023-04 hotel lobby interior",
    creator: "Svetlov Artem",
    license: "CC0 1.0",
    attributionRequired: false,
    source: "https://commons.wikimedia.org/w/index.php?curid=130945079",
  },
  {
    file: "travel/hotels/casa-jacaranda.webp",
    title: "Garden at a bed and breakfast in California",
    creator: "Tomwsulcer",
    license: "CC0 1.0",
    attributionRequired: false,
    source: "https://commons.wikimedia.org/w/index.php?curid=18750601",
  },
  {
    file: "travel/hotels/hotel-mirasol.webp",
    title: "untitled",
    creator: "Unknown",
    license: "CC0 1.0",
    attributionRequired: false,
    source: "https://www.rawpixel.com/image/5945494/free-public-domain-cc0-photo",
  },
  {
    file: "travel/hotels/la-candelaria.webp",
    title: "untitled",
    creator: "fusion-of-horizons",
    license: "CC BY",
    attributionRequired: true,
    source: "https://www.flickr.com/photos/9019841@N08/6057479916",
  },
  {
    file: "travel/hotels/patio-catedral.webp",
    title: "House at 2528 Postoffice",
    creator: "Surely Shirly",
    license: "CC0 1.0",
    attributionRequired: false,
    source: "https://www.flickr.com/photos/149130767@N03/50065488448",
  },
  {
    file: "travel/hotels/quinta-usaquen.webp",
    title: "Hotel room stock photo",
    creator: "espensorvik",
    license: "CC BY",
    attributionRequired: true,
    source: "https://www.flickr.com/photos/28478778@N05/4568472779",
  },
  {
    file: "travel/hotels/urubo.webp",
    title: "tropic",
    creator: "paul bica",
    license: "CC BY",
    attributionRequired: true,
    source: "https://www.flickr.com/photos/99771506@N00/3540011606",
  },
  {
    file: "travel/hotels/vila-madalena.webp",
    title: "Retreat?",
    creator: "benjaflynn",
    license: "CC BY",
    attributionRequired: true,
    source: "https://www.flickr.com/photos/8687249@N03/5103679082",
  },
  {
    file: "wellness/academia-corpo-livre.webp",
    title: "sweat once a day - 20100115",
    creator: "S0MEBODY 3LSE",
    license: "CC BY",
    attributionRequired: true,
    source: "https://www.flickr.com/photos/31148538@N00/4278389996",
  },
  {
    file: "wellness/bano-condesa.webp",
    title: "File:Sauna of the spa at Amantaka luxury Resort & Hotel in Luang Prabang Laos.jpg",
    creator: "Basile Morin",
    license: "CC BY-SA 4.0",
    attributionRequired: true,
    source: "https://commons.wikimedia.org/wiki/File:Sauna_of_the_spa_at_Amantaka_luxury_Resort_%26_Hotel_in_Luang_Prabang_Laos.jpg",
  },
  {
    file: "wellness/casa-mantra.webp",
    title: "Yoga Teacher Training",
    creator: "kellinahandbasket",
    license: "CC BY",
    attributionRequired: true,
    source: "https://www.flickr.com/photos/29482491@N00/4677047777",
  },
  {
    file: "wellness/centro-equipetrol.webp",
    title: "Gym Training Session - Lila and Harper",
    creator: "exit78",
    license: "CC0 1.0",
    attributionRequired: false,
    source: "https://www.flickr.com/photos/28826830@N00/54779849242",
  },
  {
    file: "wellness/estudio-aurora.webp",
    title: "Woman Yoga",
    creator: "Bruce Mars",
    license: "CC0 1.0",
    attributionRequired: false,
    source: "https://stocksnap.io/photo/woman-yoga-NK0FIGBQJM",
  },
  {
    file: "wellness/gimnasio-reforma-92.webp",
    title: "Ocean View GYM",
    creator: "Prayitno / Thank you for (12 millions +) view",
    license: "CC BY",
    attributionRequired: true,
    source: "https://www.flickr.com/photos/34128007@N04/4641005792",
  },
  {
    file: "wellness/termas-pinheiros.webp",
    title: "File:Gellert Thermal Spa A.jpg",
    creator: "Carnaval.com Studios",
    license: "CC BY 2.0",
    attributionRequired: true,
    source: "https://commons.wikimedia.org/wiki/File:Gellert_Thermal_Spa_A.jpg",
  },
]
